module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/olegarx225686762-avatar-193f53c19637b0f94198d6abf0191cea.jpg";